__turbopack_context__.v({
  "container": "BreadcrumbContainer-module-scss-module__8NlepW__container",
  "containerSticky": "BreadcrumbContainer-module-scss-module__8NlepW__containerSticky",
  "fade-in": "BreadcrumbContainer-module-scss-module__8NlepW__fade-in",
  "no-transform": "BreadcrumbContainer-module-scss-module__8NlepW__no-transform",
  "rotate": "BreadcrumbContainer-module-scss-module__8NlepW__rotate",
});
